import React from "react";
import { CancelBooking, OtherIssues, WhatIsCaptcha, WrongCredentials } from ".";
import { config, useViewport } from "../utils";

const getComponent = (pageId, width) => {
  const props = {
    width,
    breakpoint: config.BREAKPOINT
  }
  switch(pageId) {
    case config.PAGE_ID.OTHER_ISSUES:
      return <OtherIssues {...props} />
    case config.PAGE_ID.CANCEL_BOOKING:
      return <CancelBooking {...props} />
    case config.PAGE_ID.WRONG_CREDENTIALS:
      return <WrongCredentials {...props} />
    case config.PAGE_ID.CAPTCHA:
      return <WhatIsCaptcha {...props} />
    default:
      return null;
  }
}
const ComponentSwitcher = ({pageId}) => {
  const { width } = useViewport();

  return (
    <React.Fragment>
      { getComponent(pageId, width) }
    </React.Fragment>
  )
}

export default ComponentSwitcher;
